import { defineComponent as m, useCssModule as c, computed as b, openBlock as f, createBlock as g, normalizeClass as p, unref as s, withCtx as i, withDirectives as C, createElementVNode as y, mergeProps as S, vModelRadio as v, renderSlot as V } from "vue";
import k from "../../utils/propValidator.mjs";
import z from "../labelWrapper/CdrLabelWrapper.vue.mjs";
import B from "../../props/size.mjs";
import h from "../../props/background.mjs";
const P = ["name", "value", "disabled"], A = "cdr-radio", w = /* @__PURE__ */ m({
  name: "CdrRadio",
  inheritAttrs: !1,
  customOptions: {},
  __name: "CdrRadio",
  props: {
    /**
     * Adds CSS class to the label for custom styles.
     */
    labelClass: String,
    /**
     * Adds CSS class to the input for custom styles.
     */
    inputClass: String,
    /**
     * Adds CSS class to the slot wrapper for custom styles.
     */
    contentClass: String,
    /** Disables the radio */
    disabled: Boolean,
    /**
     * Sets the name of the radio button.
    */
    name: {
      type: String,
      required: !0
    },
    /**
     * Modifies the style variants for this component
     * @demoSelectMultiple true
     * @values hide-figure
    */
    modifier: {
      type: String,
      default: "",
      validator: (e) => k(e, ["", "hide-figure"])
    },
    /**
     * Sets the radio size; values can target responsive breakpoints. Example `small@lg`
     * @demoSelectMultiple false
     * @values small, medium, large
    */
    size: B,
    /**
     * Sets the background color the radio button is rendered on
     * @values primary, secondary
     */
    background: h,
    /**
     * Sets the value of the radio.
    */
    customValue: {
      type: [String, Number, Boolean, Object, Array, Symbol, Function]
    },
    /** @ignore v-model binding */
    modelValue: {
      type: [String, Number, Boolean, Object, Array, Symbol, Function]
    }
  },
  emits: {
    /**
     * Event emitted by v-model on the radio's <input> element
     * @param modelValue
     */
    "update:modelValue": null
  },
  setup(e, {
    emit: n
  }) {
    const r = e, d = n, a = c(), l = b({
      get() {
        return r.modelValue;
      },
      set(t) {
        d("update:modelValue", t);
      }
    });
    return (t, o) => (f(), g(z, {
      class: p(s(a)[A]),
      size: e.size,
      modifier: e.modifier,
      "label-class": e.labelClass,
      "content-class": e.contentClass,
      background: e.background,
      disabled: e.disabled
    }, {
      input: i(() => [C(y("input", S({
        class: [s(a)["cdr-radio__input"], e.inputClass],
        type: "radio",
        name: e.name,
        value: e.customValue
      }, t.$attrs, {
        disabled: e.disabled,
        "onUpdate:modelValue": o[0] || (o[0] = (u) => l.value = u)
      }), null, 16, P), [[v, l.value]])]),
      default: i(() => [V(t.$slots, "default")]),
      _: 3
    }, 8, ["class", "size", "modifier", "label-class", "content-class", "background", "disabled"]));
  }
});
export {
  w as default
};
